// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"AddToFavouritesButton_wrapperComponent__6Fx5L","isOnFavouriteShoppingList":"AddToFavouritesButton_isOnFavouriteShoppingList__5xPpZ"};